import GenericDB from './generic-db';

export default class PromptLevelTemplatesDB extends GenericDB {
  constructor() {
    super('promptLevelTemplates');
  }

  /**
   * Toggle lock state of selected promptLevelTemplate
   * @param {string} id
   * @param {boolean} isLocked current field status
   */
  togglePromptLevelTemplateLock(id, isLocked) {
    return this.set({ isLocked: !isLocked }, id);
  }
}
